import { routerMiddleware } from 'connected-react-router';
import socketMiddleware from '../middleware/sockets.middleware';
import { applyMiddleware, createStore } from 'redux';
import { createBrowserHistory } from 'history';

import thunk from 'redux-thunk';

import rootReducer from '../reducers/index';

export const history = createBrowserHistory();

export const store = createStore(rootReducer(history), applyMiddleware(socketMiddleware, routerMiddleware(history), thunk));
export default store;
